(function () {
    'use strict';

    angular.module("imApp").factory("poFinishProdCompAssignService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3571,
                    parameters: parms || {}
                });
            },
            saveObj: function (mergeObj) {
                return $ihttp.post({
                    method: 3573,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
